import { render, staticRenderFns } from "./ExpertDeptFeesMonth.vue?vue&type=template&id=60026268&scoped=true"
import script from "./ExpertDeptFeesMonth.vue?vue&type=script&lang=js"
export * from "./ExpertDeptFeesMonth.vue?vue&type=script&lang=js"
import style0 from "./ExpertDeptFeesMonth.vue?vue&type=style&index=0&id=60026268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60026268",
  null
  
)

export default component.exports